import type { UdsGap } from "@gatsby-plugin-generic-page/fragments/udsGap"
import type { UdsGapBreakpoint } from "@gatsby-plugin-generic-page/fragments/udsGapBreakpoint"
import { SquidexComponentType } from "@gatsby-plugin-generic-page/types/componentType"
import { typeMatches } from "@onestore-graphql"
import { cn } from "~/helpers/cn"
import isEmpty from "~/lib/isEmpty"

const GAP_BASE_CLASS: Record<string, string> = {
  tiny: "gap-1",
  small: "gap-2",
  big: "gap-3",
  large: "gap-4",
  huge: "gap-5",
}

const GAP_MD_CLASS: Record<string, string> = {
  tiny: "md:gap-1",
  small: "md:gap-2",
  big: "md:gap-3",
  large: "md:gap-4",
  huge: "md:gap-5",
}

const GAP_LG_CLASS: Record<string, string> = {
  tiny: "lg:gap-1",
  small: "lg:gap-2",
  big: "lg:gap-3",
  large: "lg:gap-4",
  huge: "lg:gap-5",
}

const DEFAULT_GAP = "big"

function getGapClass(gap: UdsGap | UdsGapBreakpoint | undefined): string {
  if (isEmpty(gap)) return GAP_BASE_CLASS[DEFAULT_GAP]

  if (typeMatches(gap.__typename, SquidexComponentType.UDS_GAP_BREAKPOINT)) {
    const gapBreakpoint = gap as UdsGapBreakpoint

    return cn(
      GAP_BASE_CLASS[gapBreakpoint.small?.gap ?? DEFAULT_GAP] ??
        GAP_BASE_CLASS[DEFAULT_GAP],
      gapBreakpoint.medium?.gap && GAP_MD_CLASS[gapBreakpoint.medium.gap],
      gapBreakpoint.large?.gap && GAP_LG_CLASS[gapBreakpoint.large.gap]
    )
  }

  return (
    GAP_BASE_CLASS[(gap as UdsGap).gap ?? DEFAULT_GAP] ??
    GAP_BASE_CLASS[DEFAULT_GAP]
  )
}

export default getGapClass
